<template>
  <div class="content" :class="showSidebar ? 'sidebar-shown' : 'sidebar-hidden'">
    <b-overlay :show="loading || overlay" variant="dark" :opacity="0.15" no-center spinner-variant="primary">
      <template #overlay>
        <b-spinner label="Loading..." variant="primary" class="position-fixed" style="top: calc(50vh + 35px); left: calc(50% + 135px);"></b-spinner>
      </template>
      <b-container :fluid="fluid" class="full-height p-4">
        <slot></slot>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    showSidebar: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: String,
      default: 'md'
    }
  },
}
</script>

<style>
  .full-height {
    min-height: calc(100vh - 110px);
  }
</style>